/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ContentMasterAiHistoryListView } from '../models/ContentMasterAiHistoryListView';
import type { ContentMasterAiTokensSummaryView } from '../models/ContentMasterAiTokensSummaryView';
import type { ContentMasterBulkEstimateView } from '../models/ContentMasterBulkEstimateView';
import type { ContentMasterBulkReviewListView } from '../models/ContentMasterBulkReviewListView';
import type { ContentMasterBulkSubmitResultView } from '../models/ContentMasterBulkSubmitResultView';
import type { ContentMasterFilterFieldListView } from '../models/ContentMasterFilterFieldListView';
import type { ContentMasterGenerateAllowedOptionView } from '../models/ContentMasterGenerateAllowedOptionView';
import type { ContentMasterGenerateResultView } from '../models/ContentMasterGenerateResultView';
import type { ContentMasterLocalProductListView } from '../models/ContentMasterLocalProductListView';
import type { ContentMasterProductListView } from '../models/ContentMasterProductListView';
import type { ContentMasterProductView } from '../models/ContentMasterProductView';
import type { ContentMasterSaveResultView } from '../models/ContentMasterSaveResultView';
import type { ContentMasterTranslateResultView } from '../models/ContentMasterTranslateResultView';
import type { ContentMasterWawiCategoryListView } from '../models/ContentMasterWawiCategoryListView';
import type { ContentMasterWawiLanguageListView } from '../models/ContentMasterWawiLanguageListView';
import type { ContentMasterWorkspaceConfigView } from '../models/ContentMasterWorkspaceConfigView';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ContentMasterService {
    /**
     * Submit a batch of products for AI generation
     * Submits N products for asynchronous bulk generation. For each `wawiArtikelId` a stub
     * `content_master_product` row is created (or reused) and the product status is set to
     * `bulk_generate_queued`. A Symfony Messenger task is dispatched per product; consumers
     * (`bin/console messenger:consume async`) pick them up one by one.
     *
     * V1 generates ALL available product fields (core + Wawi article attributes + Merkmal). The
     * client does NOT select fields — the worker resolves the list from Wawi at run time. The only
     * exception is the URL path (`urlPath`), which is generated ONLY when `includeUrlPath: true`.
     *
     * Pre-flight quota check: total projected internal-token usage =
     * current period usage + queued products at the base rate + Σ price(model, fields per product)
     * where price() is the config-driven billing formula (base + fields × per_field, × model tier) and
     * the field count per product is resolved SERVER-SIDE from Wawi (core fields + varchar non-readonly
     * attributes + Merkmale, depending on the plan) — the client sends nothing. If Wawi is unreachable
     * the submit is rejected (`content_master_wawi_connection_failed` / `content_master_wawi_error`).
     * The worker re-checks each product with the EXACT field list before generation regardless. If the
     * projected usage exceeds `totalAllowedTokens + onDemandLimitTokens`, the entire submit is rejected
     * with `content_master_quota_exceeded` (no partial accept).
     *
     * Duplicates with an active task (`bulk_*_queued` / `bulk_*_in_progress`) are silently skipped
     * and reported in `skipped[]` — not an error. Products in `done` / `bulk_generate_done` /
     * `bulk_generate_failed` / `in_progress` / `new` are accepted and re-queued.
     *
     * Status flow after handler success: `bulk_generate_queued` → `bulk_generate_in_progress` →
     * `bulk_generate_done`. Drafts are persisted in `content_master_field_version` (same as
     * `POST /content-master/save-draft`). `processingStatus` does NOT auto-revert to `in_progress` —
     * the user must call `POST /content-master/products/{id}/mark-for-edit` explicitly.
     * @param requestBody
     * @returns ContentMasterBulkSubmitResultView Submit accepted (may include silent skips)
     * @throws ApiError
     */
    public static postAppContentMasterBulkGenerate(
        requestBody: {
            /**
             * Channel identifier `plattform:N` or `shop:N` (see GET /content-master/workspace-config)
             */
            source: string;
            /**
             * Active shop language: kSprache (integer or digit string) or ISO code
             */
            language: string;
            dataSourceId?: string | null;
            /**
             * Opt-in for the URL path (`urlPath` / `cUrlPfad`). Bulk has no field picker, so the slug is generated ONLY when this is true — default false keeps the shop URLs that are already live untouched. Also affects the token estimate (one extra field per product) and is snapshotted for POST /bulk/retry.
             */
            includeUrlPath?: boolean;
            /**
             * What to do with fields the AI returns EMPTY (e.g. a picklist attribute where no allowed option fits the article). `keepOriginal` (default) — the field is skipped, no draft is saved, the current Wawi value stays. `overwriteEmpty` — the empty draft is saved and the later apply CLEARS the Wawi value. `reject` — the empty draft is saved too (nothing is lost at generation), but POST /bulk/apply REJECTS the product while any picked draft is empty: it ends as `bulk_apply_failed` with the field list in `bulk_error_message`, Wawi untouched, drafts kept for editing/re-generation. Snapshotted in `bulk_config`, so POST /bulk/retry and the apply stage reuse the original choice.
             */
            emptyFieldPolicy?: 'keepOriginal' | 'overwriteEmpty' | 'reject';
            /**
             * Wawi article ids selected by the user (one entry per product)
             */
            items: Array<{
                wawiArtikelId: number;
            }>;
        },
    ): CancelablePromise<ContentMasterBulkSubmitResultView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/content-master/bulk/generate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `\`content_master_invalid_request\` — missing/malformed body or empty items`,
                403: `Forbidden. Possible \`errorCode\`:
                - \`content_master_forbidden\` — dataSourceId does not belong to the user
                - \`content_master_quota_exceeded\` — projected usage exceeds budget
                - \`content_master_subscription_insufficient\` — bulk generation not included in the subscription plan (Starter)`,
            },
        });
    }
    /**
     * Submit a batch of products for AI translation into one or more target languages
     * Submits N products for asynchronous bulk TRANSLATION from `sourceLanguage` into every entry of
     * `targetLanguages`. Reuses the bulk generation pipeline and statuses: each product flips to
     * `bulk_generate_queued` → `bulk_generate_in_progress` → `bulk_generate_done` / `bulk_generate_failed`;
     * the task kind is recorded in the `bulk_config` snapshot (`operation: translate_all_fields`), which is
     * also what `POST /bulk/retry` routes by.
     *
     * **Multi-language chain.** Each target language is its own queue task — semantically identical to
     * submitting the same batch once per language, sequentially. Only the FIRST language is dispatched at
     * submit time; when a language completes, the worker re-queues the product and dispatches the next one
     * from `bulk_config.pendingLanguages`. A failure at language N leaves the product in
     * `bulk_generate_failed` with the failed language in `bulk_config.language`; `POST /bulk/retry` resumes
     * the chain from that language (already-translated languages are not re-billed).
     *
     * **Translated fields** (resolved server-side, no field picker): default core fields (`title`,
     * `shortDescription`, `description`, …; `urlPath` only with `includeUrlPath: true`), varchar
     * non-readonly `wawiAttr_*` attributes, and — for SCX marketplace channels (`shop:N`) — free-text
     * `mpAttr_*` category/channel attributes. Skipped: Merkmal picklists (`kMerkmalWert` ids are
     * language-independent), numeric/datetime attributes, enum/media/label marketplace attributes.
     * Source values come from the Wawi row for `sourceLanguage` (no fallback); for `mpAttr_*` the latest
     * `sourceLanguage` draft is preferred, falling back to the live SCX value (SCX storage is
     * language-less). Fields with an EMPTY source value are skipped — no draft is written.
     *
     * Results are stored as drafts in `content_master_field_version` under the target language — review
     * via `GET /bulk/review?language=<target>` and write to Wawi via the regular `POST /bulk/apply` with
     * `language = <target>`.
     *
     * Pre-flight quota: field counts per product are resolved server-side from Wawi, multiplied by the
     * number of target languages and priced with the TRANSLATE formula
     * (`content_master_base_tokens_translate` + fields × `content_master_tokens_per_field_translate`,
     * × model tier). If the projection exceeds the budget the entire submit is rejected with
     * `content_master_quota_exceeded` (no partial accept).
     *
     * Duplicates with an active task (`bulk_*` / `listing_*` queued or in progress) are silently skipped
     * into `skipped[]` with `already_in_progress` — not an error.
     * @param requestBody
     * @returns ContentMasterBulkSubmitResultView Submit accepted (may include silent skips)
     * @throws ApiError
     */
    public static postAppContentMasterBulkTranslate(
        requestBody: {
            /**
             * Channel identifier `plattform:N` or `shop:N` (see GET /content-master/workspace-config)
             */
            source: string;
            /**
             * Language to translate FROM: kSprache (integer or digit string) or ISO code. Source values are read from the Wawi row of this language, no fallback.
             */
            sourceLanguage: string;
            /**
             * Languages to translate INTO (JSON body array — never send arrays in the query string). Each must be an active shop language different from sourceLanguage; duplicates are collapsed. Each language is queued as its own task per product (sequential chain).
             */
            targetLanguages: Array<string>;
            dataSourceId?: string | null;
            /**
             * Opt-in for the URL path (`urlPath` / `cUrlPfad`) — same semantics as on POST /bulk/generate. Translated slugs are normalized server-side. Snapshotted for POST /bulk/retry.
             */
            includeUrlPath?: boolean;
            /**
             * Wawi article ids selected by the user (one entry per product)
             */
            items: Array<{
                wawiArtikelId: number;
            }>;
        },
    ): CancelablePromise<ContentMasterBulkSubmitResultView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/content-master/bulk/translate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation / service error. Possible \`errorCode\`:
                - \`content_master_invalid_request\` — missing/malformed body, empty items, or a target language equal to sourceLanguage
                - \`content_master_invalid_language\` — sourceLanguage or a target language not active in the shop
                - \`content_master_wawi_error\` / \`content_master_wawi_connection_failed\` — Wawi unreachable during the pre-flight field count`,
                403: `Forbidden. Possible \`errorCode\`:
                - \`content_master_forbidden\` — dataSourceId does not belong to the user
                - \`content_master_quota_exceeded\` — projected usage exceeds budget
                - \`content_master_subscription_insufficient\` — bulk operations not included in the subscription plan`,
            },
        });
    }
    /**
     * Estimate a super-batch "generate by filters" submit (very rough)
     * Pre-flight for `POST /bulk/generate-by-filters`: resolves how many Wawi articles currently match
     * the given search filters (the SAME `kCategory` / `fieldFilters` / `q` / `active` contract as
     * `POST /products/search`) and estimates the internal-token cost of generating all of them with the
     * EXISTING billing formula (server-side field counts per article + the same projection as the
     * id-based bulk submit).
     *
     * The numbers are a VERY ROUGH estimate (`isRoughEstimate` is always true): the article set and
     * field counts are read live from Wawi at call time and the workers re-check every product before
     * generation. There is no time estimate. `wouldExceedBudget = true` does NOT block the submit —
     * generation proceeds until the budget runs out and the remaining articles are simply not enqueued.
     *
     * MARKETPLACE LISTING MODE: send a `listingConfig` object (same parameters and defaults as
     * `POST /marketplace-listing/generate`) to estimate the LISTING flow instead — `totalFields` /
     * `estimatedTokens` are then computed from the SCX attribute counts of the SELECTED groups
     * (`generateRequired` / `generateRecommended` / `generateOther`) plus ONE field per article for the
     * per-channel product description (always generated in listing mode), with the category auto-detect
     * priced for articles without a category when `autoDetectCategory` is true. Marketplace (SCX)
     * channels only: `listingConfig` on a non-marketplace source is rejected with 400
     * `content_master_invalid_request`. Omit `listingConfig` for the classic CM generation.
     *
     * Requires a plan with bulk generation (403 `content_master_subscription_insufficient` otherwise;
     * listing mode additionally requires marketplace listing generation in the plan).
     * Wawi unavailability rejects the call (`content_master_wawi_connection_failed` / `content_master_wawi_error`).
     * @param requestBody
     * @returns ContentMasterBulkEstimateView Rough estimate (jobId is null on this endpoint)
     * @throws ApiError
     */
    public static postAppContentMasterBulkEstimateByFilters(
        requestBody: {
            /**
             * Channel identifier `plattform:N` or `shop:N` (see GET /content-master/workspace-config)
             */
            source: string;
            /**
             * Active shop language: kSprache (integer or digit string) or ISO code
             */
            language: string;
            dataSourceId?: string | null;
            /**
             * Opt-in for the URL path (`urlPath` / `cUrlPfad`). Bulk has no field picker, so the slug is generated ONLY when this is true — default false keeps the shop URLs that are already live untouched. Also affects the token estimate (one extra field per product) and is snapshotted for POST /bulk/retry.
             */
            includeUrlPath?: boolean;
            /**
             * Category filter — SCX category id for marketplace channels, Wawi kKategorie otherwise. Exact match by default, see includeSubcategories. Same contract as POST /products/search.
             */
            kCategory?: number | null;
            /**
             * Native Wawi category filter (dbo.tkategorie kKategorie, see GET /content-master/categories) — works on EVERY channel type and is AND-combined with kCategory, so on an SCX marketplace both the SCX category and the Wawi category can be filtered at once. Subtree expansion follows the same includeSubcategories flag.
             */
            kWawiCategory?: number | null;
            /**
             * true = the kCategory filter also matches ALL descendant categories (full subtree). Default false = exact match. Ignored without kCategory.
             */
            includeSubcategories?: boolean;
            /**
             * Same contract as POST /products/search: only articles with JTL-Wawi stock > 0 (dbo.tlagerbestand.fLagerbestand).
             */
            onlyInStock?: boolean;
            /**
             * Same contract as POST /products/search: only articles with a non-empty EAN/GTIN (dbo.tArtikel.cBarcode).
             */
            onlyWithEan?: boolean;
            /**
             * Same contract as POST /products/search: only articles NOT activated for the marketplace channel in JTL-Wawi (dbo.tArtikelShop). SCX marketplace sources only; 400 otherwise.
             */
            onlyNotActivated?: boolean;
            /**
             * Field → phrase filters, AND-combined (max 10). Same contract as POST /products/search; keys from GET /content-master/filter-fields.
             */
            fieldFilters?: Array<{
                field: string;
                value: string;
            }> | null;
            /**
             * Optional local status filter, same contract as the products list (one value or comma-separated; `new` cannot be combined with others). To RESUME an interrupted super batch, re-submit the same filters with `processingStatus=new` — only articles never touched before are picked up.
             */
            processingStatus?: string | null;
            /**
             * Optional free-text search (SKU/GTIN/HAN/title contains) — carry it over from the search UI so the batch matches what the user sees
             */
            'q'?: string | null;
            /**
             * Optional Wawi active-flag filter — carry it over from the search UI
             */
            active?: boolean | null;
            /**
             * Presence switches the super batch to the MARKETPLACE LISTING flow (SCX channels only). Same parameters and defaults as POST /marketplace-listing/generate; omit for the classic CM generation.
             */
            listingConfig?: {
                /**
                 * Override; omit to auto-detect from the channel
                 */
                marketplace?: 'amazon' | 'otto' | 'kaufland' | 'metro' | 'cdiscount' | 'tiktok' | null;
                /**
                 * Generate required ("Pflichtfelder") attributes. Default true when omitted.
                 */
                generateRequired?: boolean | null;
                /**
                 * Generate recommended attributes. Default false when omitted.
                 */
                generateRecommended?: boolean | null;
                /**
                 * Generate other (neither required nor recommended) attributes. Default false when omitted.
                 */
                generateOther?: boolean | null;
                /**
                 * When an article has no marketplace category selected, AI-detect and assign the best-fitting one before generating. Default false: such articles finish as category_not_selected without AI cost.
                 */
                autoDetectCategory?: boolean | null;
                /**
                 * Whether to AI-generate attributes that already carry a Wawi channel/category DEFAULT value. Default false: such attributes are skipped, Wawi keeps filling them itself.
                 */
                generatePrefilled?: boolean | null;
                /**
                 * "Fill only empty fields": skip attributes that already have a value in Wawi for this channel and skip the description when the channel has its own non-empty one; a product with nothing left to generate ends as listing_generate_done without an AI call. Ignored when an explicit `fields` list is given. Default false.
                 */
                onlyEmptyFields?: boolean | null;
            } | null;
        },
    ): CancelablePromise<ContentMasterBulkEstimateView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/content-master/bulk/estimate-by-filters',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request/filters/language or Wawi error`,
                403: `Forbidden. Possible \`errorCode\`:
                - \`content_master_forbidden\` — dataSourceId does not belong to the user
                - \`content_master_subscription_insufficient\` — bulk generation not included in the subscription plan`,
            },
        });
    }
    /**
     * Submit a super-batch: generate ALL products matching the search filters
     * Filter-based twin of `POST /bulk/generate` for large result sets ("generate everything matching
     * these filters" — no more clicking through pagination). The request carries the SAME filter contract
     * as `POST /products/search` (`kCategory` / `fieldFilters` / `q` / `active`); there is NO items list
     * and NO size cap.
     *
     * What happens: a job row stores the filters, ONE filler task walks the matching Wawi articles in
     * chunks (kArtikel cursor, ascending) and — through the same enqueue path as the id-based submit —
     * creates/reuses `content_master_product` stubs and dispatches the existing per-product generation
     * tasks. Products with an active bulk task are silently skipped (`already_in_progress` semantics).
     * Articles added or changed after the cursor passed them are NOT picked up (no snapshot, by design).
     *
     * Budget: unlike `POST /bulk/generate` (all-or-nothing 403), the filler generates UNTIL THE TOKEN
     * BUDGET RUNS OUT — when a chunk would exceed the budget the job stops (`budget_exhausted`) and the
     * remaining articles are simply not enqueued. `wouldExceedBudget = true` in the response therefore
     * means "part of the set will not be processed", not an error.
     *
     * MARKETPLACE LISTING MODE: send a `listingConfig` object (same parameters and defaults as
     * `POST /marketplace-listing/generate`) and the job dispatches the SAME listing tasks instead
     * (statuses `listing_generate_*`, generation parameters snapshotted in `bulk_config` so
     * `POST /bulk/retry` works from the product id alone). Articles without a category and
     * `autoDetectCategory=false` are still accepted — the worker finishes them as
     * `category_not_selected` without AI cost. In this mode a chunk that no longer fits the budget is
     * rejected whole (all-or-nothing per chunk) before the job stops with `budget_exhausted`.
     * Marketplace (SCX) channels only: `listingConfig` on a non-marketplace source is rejected with
     * 400 `content_master_invalid_request`. Omit `listingConfig` for the classic CM generation.
     *
     * The response mirrors `POST /bulk/estimate-by-filters` (computed at submit time) plus `jobId`.
     * There is NO job status or cancel endpoint — the client tracks progress through the regular
     * `processingStatus` counts (`GET /products?countsOnly=true`, `GET /products/local`, `GET /bulk/review`).
     * @param requestBody
     * @returns ContentMasterBulkEstimateView Job accepted; response = the estimate at submit time + jobId
     * @throws ApiError
     */
    public static postAppContentMasterBulkGenerateByFilters(
        requestBody: {
            /**
             * Channel identifier `plattform:N` or `shop:N` (see GET /content-master/workspace-config)
             */
            source: string;
            /**
             * Active shop language: kSprache (integer or digit string) or ISO code
             */
            language: string;
            dataSourceId?: string | null;
            /**
             * Opt-in for the URL path (`urlPath` / `cUrlPfad`). Bulk has no field picker, so the slug is generated ONLY when this is true — default false keeps the shop URLs that are already live untouched. Also affects the token estimate (one extra field per product) and is snapshotted for POST /bulk/retry.
             */
            includeUrlPath?: boolean;
            /**
             * What to do with fields the AI returns EMPTY — same contract as POST /bulk/generate: `keepOriginal` (default) skips the field so the Wawi value stays, `overwriteEmpty` saves the empty draft (apply then CLEARS the Wawi value), `reject` saves the empty draft too but POST /bulk/apply REJECTS the product while empty drafts exist (`bulk_apply_failed`, Wawi untouched, drafts kept). Snapshotted per product for POST /bulk/retry and the apply stage. Ignored by /bulk/estimate-by-filters (no cost impact). Classic CM generation only — the listing flow has its own empty handling.
             */
            emptyFieldPolicy?: 'keepOriginal' | 'overwriteEmpty' | 'reject';
            /**
             * Category filter — same contract as POST /products/search (exact match by default, see includeSubcategories)
             */
            kCategory?: number | null;
            /**
             * Native Wawi category filter (dbo.tkategorie kKategorie, see GET /content-master/categories) — works on EVERY channel type and is AND-combined with kCategory, so on an SCX marketplace both the SCX category and the Wawi category can be filtered at once. Subtree expansion follows the same includeSubcategories flag.
             */
            kWawiCategory?: number | null;
            /**
             * true = the kCategory filter also matches ALL descendant categories (full subtree). Default false = exact match.
             */
            includeSubcategories?: boolean;
            /**
             * Same contract as POST /products/search: only articles with JTL-Wawi stock > 0 (dbo.tlagerbestand.fLagerbestand).
             */
            onlyInStock?: boolean;
            /**
             * Same contract as POST /products/search: only articles with a non-empty EAN/GTIN (dbo.tArtikel.cBarcode).
             */
            onlyWithEan?: boolean;
            /**
             * Same contract as POST /products/search: only articles NOT activated for the marketplace channel in JTL-Wawi (dbo.tArtikelShop). SCX marketplace sources only; 400 otherwise.
             */
            onlyNotActivated?: boolean;
            /**
             * Field → phrase filters, AND-combined (max 10). Same contract as POST /products/search.
             */
            fieldFilters?: Array<{
                field: string;
                value: string;
            }> | null;
            /**
             * Optional local status filter, same contract as the products list. To RESUME an interrupted super batch, re-submit the same filters with `processingStatus=new`.
             */
            processingStatus?: string | null;
            /**
             * Optional free-text search — carry it over from the search UI
             */
            'q'?: string | null;
            /**
             * Optional Wawi active-flag filter — carry it over from the search UI
             */
            active?: boolean | null;
            /**
             * Presence switches the super batch to the MARKETPLACE LISTING flow (SCX channels only). Same parameters and defaults as POST /marketplace-listing/generate; send the SAME object to estimate-by-filters and here. Omit for the classic CM generation.
             */
            listingConfig?: {
                /**
                 * Override; omit to auto-detect from the channel
                 */
                marketplace?: 'amazon' | 'otto' | 'kaufland' | 'metro' | 'cdiscount' | 'tiktok' | null;
                /**
                 * Generate required ("Pflichtfelder") attributes. Default true when omitted.
                 */
                generateRequired?: boolean | null;
                /**
                 * Generate recommended attributes. Default false when omitted.
                 */
                generateRecommended?: boolean | null;
                /**
                 * Generate other (neither required nor recommended) attributes. Default false when omitted.
                 */
                generateOther?: boolean | null;
                /**
                 * When an article has no marketplace category selected, AI-detect and assign the best-fitting one before generating. Default false: such articles finish as category_not_selected without AI cost.
                 */
                autoDetectCategory?: boolean | null;
                /**
                 * Whether to AI-generate attributes that already carry a Wawi channel/category DEFAULT value. Default false: such attributes are skipped, Wawi keeps filling them itself.
                 */
                generatePrefilled?: boolean | null;
                /**
                 * "Fill only empty fields": skip attributes that already have a value in Wawi for this channel and skip the description when the channel has its own non-empty one; a product with nothing left to generate ends as listing_generate_done without an AI call. Ignored when an explicit `fields` list is given. Default false.
                 */
                onlyEmptyFields?: boolean | null;
            } | null;
        },
    ): CancelablePromise<ContentMasterBulkEstimateView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/content-master/bulk/generate-by-filters',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request/filters/language or Wawi error`,
                403: `Forbidden. Possible \`errorCode\`:
                - \`content_master_forbidden\` — dataSourceId does not belong to the user
                - \`content_master_subscription_insufficient\` — bulk generation not included in the subscription plan`,
            },
        });
    }
    /**
     * Submit a batch of products to be applied to Wawi
     * Submits N products for asynchronous apply-to-Wawi. This is the SINGLE apply entry point — the
     * backend resolves the apply type per product:
     * - Regular Content Master products: the handler reads the latest stored draft versions per field and
     * replays them through the existing `POST /content-master/apply` path (single transaction Wawi+S2G).
     * Status flow: `bulk_apply_queued` → `bulk_apply_in_progress` → `done` (success) or
     * `bulk_apply_failed` (failure). Note: there is no `bulk_apply_done`.
     * - Marketplace listing products (generated via `POST /marketplace-listing/generate`): the latest
     * marketplace attribute drafts for the language are written to the SCX schema
     * (`SCX.tArtikelVerkaufskanalFeldWert`) and the latest `description` draft to the channel's
     * `dbo.tArtikelBeschreibung` row — one transaction, same path as `POST /content-master/apply`.
     * Status flow: `listing_apply_queued` → `listing_apply_in_progress` → `done` (success; or
     * `in_progress` when other languages still hold drafts) or `listing_apply_failed` (failure).
     *
     * `fields` are NOT sent by the client — the worker uses the latest draft per field/attribute. If the
     * product has no drafts on the requested language, the task fails and the message is recorded in
     * `bulk_error_message`. Products with any task already active (bulk OR listing) are silently skipped.
     *
     * MULTI-LANGUAGE: the same `contentMasterProductId` may appear with SEVERAL languages in one request
     * (e.g. after a multi-language bulk translate) — the languages are grouped per product and applied
     * sequentially as a chain (one queue task per language, next dispatched when the previous succeeds).
     * The response contains ONE `accepted` entry per product. A failure at language N ends the product as
     * `bulk_apply_failed` / `listing_apply_failed`; `POST /bulk/retry` resumes from the failed language —
     * already-applied languages are not re-applied.
     *
     * When the product was bulk-generated with `emptyFieldPolicy=reject` and any picked draft is EMPTY,
     * the apply is REJECTED: the product ends as `bulk_apply_failed` with the empty field list in
     * `bulk_error_message`, Wawi is not touched and the drafts are kept — edit or re-generate the empty
     * fields and retry.
     * @param requestBody
     * @returns ContentMasterBulkSubmitResultView Submit accepted
     * @throws ApiError
     */
    public static postAppContentMasterBulkApply(
        requestBody: {
            dataSourceId?: string | null;
            /**
             * Products to apply
             */
            items: Array<{
                contentMasterProductId: string;
                /**
                 * Language to apply (same shape as POST /apply)
                 */
                language: string;
            }>;
        },
    ): CancelablePromise<ContentMasterBulkSubmitResultView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/content-master/bulk/apply',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `\`content_master_invalid_request\``,
                403: `\`content_master_forbidden\``,
            },
        });
    }
    /**
     * Re-queue previously failed products (bulk AND marketplace listing) from the product id alone
     * The SINGLE retry entry point: retries products in ANY `*_failed` status — Content Master bulk and
     * marketplace listing alike. The server decides per-item which worker to re-dispatch based on the
     * product's current `processingStatus`:
     *
     * - `bulk_generate_failed`    → `bulk_generate_queued`, a `BulkGenerateContentMasterProductMessage` is dispatched.
     * - `bulk_apply_failed`       → `bulk_apply_queued`, a `BulkApplyContentMasterProductMessage` is dispatched.
     * - `listing_generate_failed` → `listing_generate_queued`, a `GenerateListingFieldsMessage` is dispatched.
     * - `listing_apply_failed`    → `listing_apply_queued`, an `ApplyListingFieldsMessage` is dispatched.
     *
     * Everything needed to rebuild the task (`source`, `language`, and for listing generation the
     * `marketplace` override + attribute-group flags + auto-detect) is read from the snapshot stored in
     * `content_master_product.bulk_config` at the original submit. The client only sends the product
     * id — no `language`, no `source`, no generation flags.
     *
     * `language` per item is OPTIONAL and only used as a backward-compat fallback for products that
     * failed BEFORE the snapshot existed for their pipeline (bulk products from before the
     * `bulk_config` column; listing products submitted before listing snapshots were introduced). For
     * such legacy bulk rows the snapshot is back-filled on the first successful retry.
     *
     * Silent-skip semantics (no error, returned in `skipped[]`):
     * - `forbidden_or_not_found` — product not owned by the user or unknown id.
     * - `already_in_progress` — product currently has an active task (`bulk_*` or `listing_*`, queued or in progress).
     * - `missing_bulk_config` — legacy failed product without `bulk_config` and the client did not pass
     * `language` as a fallback. Re-submit it once via `POST /bulk/generate` (bulk) or
     * `POST /marketplace-listing/generate` (listing) to recover.
     * - `not_failed` — product is in any other status (`done`, `bulk_generate_done`, `in_progress`,
     * `rejected_by_user`, …) and has nothing to retry. To re-generate a successful product, call the
     * matching generate endpoint directly.
     *
     * Pre-flight quota check is applied to the products routed to generate-retry (bulk AND listing
     * generation both consume AI tokens; apply-retry does not). Field/attribute counts per product are
     * resolved SERVER-SIDE from Wawi/SCX with the same estimator as the submit endpoints (the client
     * sends nothing); listing retries reuse the generate flags from each product's `bulk_config`
     * snapshot. Wawi unreachable → the request is rejected (`content_master_wawi_connection_failed` /
     * `content_master_wawi_error`). If the projected period usage would exceed
     * `totalAllowedTokens + onDemandLimitTokens`, the entire request is rejected with
     * `content_master_quota_exceeded` (no partial accept) — same contract as `POST /bulk/generate`.
     *
     * "Retry all" mode: send `{"all": true}` instead of `items` — the server itself collects EVERY
     * product of the user currently in a retryable `*_failed` status (all four listed above) for the
     * resolved data source and re-queues them. `items` is ignored in this mode. Per-item routing,
     * `skipped[]` semantics and the pre-flight quota check are identical to the item-list mode. When
     * nothing is failed, returns 200 with empty `accepted`/`skipped` (idempotent, not an error).
     * @param requestBody
     * @returns ContentMasterBulkSubmitResultView Submit accepted (may include silent skips)
     * @throws ApiError
     */
    public static postAppContentMasterBulkRetry(
        requestBody: {
            dataSourceId?: string | null;
            /**
             * Retry every failed product of the user (server-side selection); `items` is ignored.
             */
            all?: boolean;
            /**
             * Products to retry
             */
            items?: Array<{
                contentMasterProductId: string;
                /**
                 * OPTIONAL. Legacy fallback for products without `bulk_config` (failed before this column existed). New clients should omit it — the server reads the language from the product's saved snapshot.
                 */
                language?: string | null;
            }>;
        },
    ): CancelablePromise<ContentMasterBulkSubmitResultView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/content-master/bulk/retry',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `\`content_master_invalid_request\``,
                403: `Forbidden. Possible \`errorCode\`:
                - \`content_master_forbidden\` — dataSourceId does not belong to the user
                - \`content_master_quota_exceeded\` — projected usage exceeds budget
                - \`content_master_subscription_insufficient\` — bulk generation not included in the subscription plan (Starter)`,
            },
        });
    }
    /**
     * Dismiss failed products the user does not want to retry (batch)
     * Batch "reject by user": moves FAILED products to `processingStatus = rejected_by_user` and clears
     * `bulk_error_message`, so they stop cluttering the failed tabs. Only products currently in
     * `bulk_generate_failed` / `bulk_apply_failed` / `listing_generate_failed` / `listing_apply_failed`
     * are accepted; any other status is skipped with reason `not_failed` (foreign or unknown ids with
     * `forbidden_or_not_found`). Returns 200 even if `accepted` is empty.
     *
     * There is no "un-reject": a rejected product is simply re-queued by the next generate/apply submit
     * (`rejected_by_user` is not an active status, so no duplicate-task guard blocks it). List rejected
     * products via `GET /content-master/products/local?processingStatus=rejected_by_user`.
     * @param requestBody
     * @returns ContentMasterBulkSubmitResultView Reject processed (may include silent skips)
     * @throws ApiError
     */
    public static postAppContentMasterProductsReject(
        requestBody: {
            dataSourceId?: string | null;
            /**
             * Failed products to reject
             */
            items: Array<{
                contentMasterProductId: string;
            }>;
        },
    ): CancelablePromise<ContentMasterBulkSubmitResultView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/content-master/products/reject',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `\`content_master_invalid_request\``,
                403: `\`content_master_forbidden\` — dataSourceId does not belong to the user`,
            },
        });
    }
    /**
     * Move a product to in_progress so the user can edit it manually
     * Sets `processingStatus = in_progress` and clears `bulk_error_message`. Used by the UI when the
     * user wants to take a product out of a `bulk_*_done` / `bulk_*_failed` state and continue editing
     * it manually (existing `POST /save-draft` / `POST /apply` endpoints).
     *
     * Refused with 409 `content_master_bulk_job_already_active` while the product is in
     * `bulk_*_queued` / `bulk_*_in_progress` — wait for the worker to finish or for the L4
     * crash-recovery to time out (see plan §11).
     * @param id
     * @returns any Product moved to in_progress
     * @throws ApiError
     */
    public static postAppContentMasterProductMarkForEdit(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/content-master/products/{id}/mark-for-edit',
            path: {
                'id': id,
            },
            errors: {
                403: `\`content_master_forbidden\``,
                409: `\`content_master_bulk_job_already_active\` — product currently in a bulk task`,
            },
        });
    }
    /**
     * List products with original/generated diff for the bulk review page
     * Paginated list designed for the "Review & Approve Generated Products" screen. For every returned
     * product we attach a `languages` map keyed by storage language code. Each language entry contains
     * a `fields[]` list with every stored draft paired with the matching original Wawi value — so the
     * client can render the side-by-side comparison without drilling into each product separately.
     *
     * `fields[]` per language is the union of:
     * - the 6 core `tArtikelBeschreibung` fields (`title`, `shortDescription`, …) when a draft exists,
     * - every Wawi article attribute (`wawiAttr_*`) draft (`original`/`generated` are raw text),
     * - every Merkmal (`wawiMerkmal_*`) draft. For these, `original`/`generated` are the LOCALIZED
     * LABELS resolved from the per-product cache (`content_master_product.cached_config.merkmalLabels`,
     * filled at bulk-generate time). The raw `kMerkmalWert` ids are exposed in
     * `kMerkmalWertOriginal`/`kMerkmalWertGenerated` for the apply payload.
     *
     * `language` query is OPTIONAL. Omit it to receive ALL languages a product has drafts in (default).
     * Pass a concrete `language` (kSprache or ISO code) to filter the response to a single language.
     *
     * Items WITHOUT any stored drafts return an empty `languages` object — they're still listed, but
     * there is nothing to compare.
     *
     * **Statuses (`processingStatus` query):** comma-separated. Default `bulk_generate_done` (the
     * classic review-and-approve flow). Allowed values:
     * `in_progress`, `bulk_generate_done`, `bulk_generate_failed`, `bulk_apply_failed`. Other statuses
     * are rejected with `content_master_invalid_request` — actively-processing products
     * (`bulk_*_queued` / `bulk_*_in_progress`) are intentionally excluded because their drafts may be
     * mid-flight; the frontend filters those into a dedicated "Processing" tab using `/products`.
     *
     * Pagination follows the same convention as `/products` (`page`, `limit`, defaults 1 / 20,
     * max 100). Results are ordered by `content_master_product.updatedAt DESC` so the most recently
     * generated batch lands at the top.
     * @param source OPTIONAL channel filter (`plattform:N` / `shop:N`). Omit to review products across ALL channels of the data source (Ready/Errors tabs without re-selecting a channel).
     * @param language OPTIONAL. When provided, the response only contains drafts in this language (kSprache or ISO code). When omitted, the response includes EVERY language with at least one stored draft, grouped under `items[].languages[<storageCode>]`.
     * @param dataSourceId
     * @param page
     * @param limit
     * @param processingStatus Comma-separated. Allowed: `in_progress`, `bulk_generate_done`, `bulk_generate_failed`, `bulk_apply_failed`. Default `bulk_generate_done`.
     * @returns ContentMasterBulkReviewListView Page of review items
     * @throws ApiError
     */
    public static getAppContentMasterBulkReview(
        source?: string,
        language?: string,
        dataSourceId?: string,
        page: number = 1,
        limit: number = 20,
        processingStatus?: string,
    ): CancelablePromise<ContentMasterBulkReviewListView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/content-master/bulk/review',
            query: {
                'source': source,
                'language': language,
                'dataSourceId': dataSourceId,
                'page': page,
                'limit': limit,
                'processingStatus': processingStatus,
            },
            errors: {
                400: `\`content_master_invalid_request\` / \`content_master_invalid_language\``,
                403: `\`content_master_forbidden\``,
            },
        });
    }
    /**
     * Search products in Wawi (UC-01, UC-04)
     * List and filter articles from the user's JTL-Wawi database. Results are scoped to the selected channel: only articles actually listed on the `source` are returned, mirroring `dbo.ifGetPlattformsForItem` (Amazon via `pf_amazon_angebot`, eBay via `ebay_item`, shops via `dbo.tArtikelShop.cDelInet`). The master JTL-Wawi platform (`tPlattform.nTyp = 1`) is the global catalogue and returns every article. **No request body** (GET; filters are query parameters). No S2G row is created. See docs/CONTENT_MASTER_PLAN_1.md and docs/CONTENT_MASTER_WAWI_UC04_MAPPING.md.
     * @param source Channel identifier — composite string `plattform:N` (master / marketplace platform from `dbo.tPlattform`) or `shop:N` (shop instance from `dbo.tShop`). Use the `id` of any entry in `GET /content-master/workspace-config.platforms`.
     * @param dataSourceId Optional; must match the authenticated user's data source when provided
     * @param page
     * @param limit
     * @param language Active shop language: kSprache (integer or digit string), or ISO code (cISO2/cISO from Wawi tSpracheUsed). Omit for shop default.
     * @param q Single search string: contains-match on SKU, GTIN, HAN, and title (per Wawi mapping)
     * @param processingStatus Filter by local Content Master status; one value or comma-separated. Allowed: `new`, `in_progress`, `done`, plus the bulk states: `bulk_generate_queued`, `bulk_generate_in_progress`, `bulk_generate_done`, `bulk_generate_failed`, `bulk_apply_queued`, `bulk_apply_in_progress`, `bulk_apply_failed`.
     * @param active Filter by Wawi article active flag (`dbo.tArtikel.cAktiv`). Omit for all products; `true` returns only active (`cAktiv = 'Y'`); `false` returns only inactive (`cAktiv = 'N'`).
     * @param includeUnassigned Marketplace sources (`shop:N` of an SCX channel) only; ignored elsewhere. Default `false`: the list shows only articles already enrolled into the channel (an SCX assignment exists). `true`: the WHOLE Wawi catalogue becomes searchable/listable — use it to find any article by SKU/name and enrol it into the channel (assign a category). Such articles appear with `marketplace.status = category_not_selected`.
     * @param countsOnly If `true` (or `1`), the endpoint returns ONLY `processingStatusCounts` (counts of the user's Content Master products by status for the given `source`, legacy `new` excluded). All other query parameters except `source` and `dataSourceId` are ignored; no Wawi lookup is performed.
     * @returns ContentMasterProductListView Product list. When `countsOnly=true`, only `processingStatusCounts` is populated (other fields left at defaults).
     * @throws ApiError
     */
    public static getAppContentMasterProductsList(
        source: string,
        dataSourceId?: string,
        page: number = 1,
        limit: number = 20,
        language?: string,
        q?: string,
        processingStatus?: string,
        active?: boolean,
        includeUnassigned: boolean = false,
        countsOnly: boolean = false,
    ): CancelablePromise<ContentMasterProductListView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/content-master/products',
            query: {
                'source': source,
                'dataSourceId': dataSourceId,
                'page': page,
                'limit': limit,
                'language': language,
                'q': q,
                'processingStatus': processingStatus,
                'active': active,
                'includeUnassigned': includeUnassigned,
                'countsOnly': countsOnly,
            },
            errors: {
                400: `Invalid parameters or Wawi query error`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Search products in Wawi with extended filters (POST twin of GET /products)
     * Same behaviour and response shape as `GET /content-master/products`, but parameters travel in the
     * JSON body and two extra filters are available:
     *
     * - `kCategory` — category filter (exact match, no subtree). For SCX marketplace channels this is the
     * SCX category id (`GET /marketplace-listing/categories`); for all other channels the native Wawi
     * category (`dbo.tkategorie`, see `GET /content-master/categories`).
     * - `kWawiCategory` — native Wawi category filter on ANY channel type, AND-combined with `kCategory`:
     * on an SCX marketplace this filters by the article's JTL-Wawi category structure next to (or
     * instead of) the SCX category. `includeSubcategories` applies to both.
     * - `fieldFilters` — up to 10 field → phrase filters, AND-combined, contains-match (case-insensitive
     * per MSSQL collation). Allowed `field` keys: core apiNames (`title`, `shortDescription`,
     * `description`, `metaTitleTag`, `metaKeywords`, `metaDescription`, `urlPath`), `anmerkung` (article
     * internal note `dbo.tArtikel.cAnmerkung`, language/channel independent), `wawiAttribut_{kAttribut}`
     * (Wawi article attribute definition), `wawiMerkmal_{kMerkmal}`, and `mpAttr_{cAttributeId}`
     * (SCX marketplace channels only). Use `GET /content-master/filter-fields` to list the available
     * keys with labels.
     * - `onlyInStock` / `onlyWithEan` / `onlyNotActivated` — boolean JTL-Wawi flags, each independent and
     * AND-combined with everything else: stock > 0 (`dbo.tlagerbestand.fLagerbestand`), non-empty EAN
     * (`dbo.tArtikel.cBarcode`), not activated for the selected marketplace channel (no active
     * `dbo.tArtikelShop` row for the channel — SCX marketplaces only, 400 otherwise).
     *
     * The SAME filter object (`kCategory` + `kWawiCategory` + `fieldFilters` + the three `only*` flags) is accepted by
     * `POST /bulk/estimate-by-filters` and `POST /bulk/generate-by-filters`, so "generate everything
     * matching these filters" reuses the search filter state 1:1.
     * @param requestBody
     * @returns ContentMasterProductListView Product list (same shape as GET /products). When `countsOnly=true`, only `processingStatusCounts` is populated.
     * @throws ApiError
     */
    public static postAppContentMasterProductsSearch(
        requestBody: {
            /**
             * Channel identifier — composite string `plattform:N` (master / marketplace platform from `dbo.tPlattform`) or `shop:N` (shop instance from `dbo.tShop`). Use the `id` of any entry in `GET /content-master/workspace-config.platforms`.
             */
            source: string;
            dataSourceId?: string | null;
            page?: number;
            limit?: number;
            /**
             * Active shop language: kSprache (integer or digit string), or ISO code (cISO2/cISO from Wawi tSpracheUsed). Omit for shop default.
             */
            language?: string | null;
            /**
             * Contains-match on SKU, GTIN, HAN and title (same as GET `q`)
             */
            'q'?: string | null;
            /**
             * Same contract as the GET parameter (one value or comma-separated)
             */
            processingStatus?: string | null;
            active?: boolean | null;
            includeUnassigned?: boolean;
            countsOnly?: boolean;
            /**
             * Category filter. SCX category id for marketplace channels, Wawi kKategorie otherwise. Exact match by default — see includeSubcategories.
             */
            kCategory?: number | null;
            /**
             * Native Wawi category filter (dbo.tkategorie kKategorie, see GET /content-master/categories) — works on EVERY channel type and is AND-combined with kCategory, so on an SCX marketplace both the SCX category and the Wawi category can be filtered at once. Subtree expansion follows the same includeSubcategories flag.
             */
            kWawiCategory?: number | null;
            /**
             * true = the kCategory filter also matches ALL descendant categories (full subtree, e.g. "Elektronik" incl. "Monitore", "Tablets"). Default false = exact match. Ignored without kCategory.
             */
            includeSubcategories?: boolean;
            /**
             * true = only articles whose JTL-Wawi stock level is above zero (dbo.tlagerbestand.fLagerbestand > 0, own + supplier stock). Articles with zero/negative stock or without a stock row are hidden.
             */
            onlyInStock?: boolean;
            /**
             * true = only articles with a non-empty EAN/GTIN in JTL-Wawi (dbo.tArtikel.cBarcode).
             */
            onlyWithEan?: boolean;
            /**
             * true = only articles NOT activated for the selected marketplace channel in JTL-Wawi (no active dbo.tArtikelShop row for the channel kShop — activation on other channels is irrelevant). SCX marketplace sources only; 400 invalid_request otherwise. Tip: combine with includeUnassigned=true to also see articles that have no SCX category yet.
             */
            onlyNotActivated?: boolean;
            /**
             * Field → phrase filters, AND-combined (max 10). Field keys from GET /content-master/filter-fields.
             */
            fieldFilters?: Array<{
                field: string;
                value: string;
            }> | null;
        },
    ): CancelablePromise<ContentMasterProductListView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/content-master/products/search',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid parameters (\`content_master_invalid_request\`, e.g. unknown fieldFilters key or \`mpAttr_*\`/\`kCategory\` misuse) or Wawi query error`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * List available field keys for the product search filters
     * Returns the "field" keys the user can pick in the search-filter UI, grouped with human-readable
     * labels: static core fields (plus `anmerkung` — the article internal note), Wawi article attribute definitions (`wawiAttribut_{kAttribut}`,
     * varchar/non-readonly — the same subset bulk generation targets), Merkmale (`wawiMerkmal_{kMerkmal}`)
     * and — for SCX marketplace sources with `kCategory` — SCX listing attributes (`mpAttr_{cAttributeId}`,
     * category + channel-wide, generatable types only). The returned `field` values are what
     * `POST /products/search`, `/bulk/estimate-by-filters` and `/bulk/generate-by-filters` expect in
     * `fieldFilters[].field`. `q` filters every group by label.
     * @param source Channel identifier — composite string `plattform:N` (master / marketplace platform from `dbo.tPlattform`) or `shop:N` (shop instance from `dbo.tShop`). Use the `id` of any entry in `GET /content-master/workspace-config.platforms`.
     * @param dataSourceId
     * @param language Active shop language: kSprache (integer or digit string), or ISO code (cISO2/cISO from Wawi tSpracheUsed). Omit for shop default.
     * @param q Label search (contains, case-insensitive), applied to every group
     * @param kCategory SCX marketplace sources only: category whose listing attributes to include in `mpAttributes`
     * @param limit Max entries per group
     * @returns ContentMasterFilterFieldListView Grouped filterable field keys with labels
     * @throws ApiError
     */
    public static getAppContentMasterFilterFields(
        source: string,
        dataSourceId?: string,
        language?: string,
        q?: string,
        kCategory?: number,
        limit: number = 50,
    ): CancelablePromise<ContentMasterFilterFieldListView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/content-master/filter-fields',
            query: {
                'source': source,
                'dataSourceId': dataSourceId,
                'language': language,
                'q': q,
                'kCategory': kCategory,
                'limit': limit,
            },
            errors: {
                400: `Invalid parameters or Wawi query error`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Search the native Wawi category tree
     * Native Wawi categories (`dbo.tkategorie`, names from `dbo.tKategorieSprache`) for ANY source —
     * the counterpart of `GET /marketplace-listing/categories` (which serves the SCX category tree of a
     * marketplace). The returned `kCategory` (= Wawi `kKategorie`) is what `POST /products/search` and the
     * super-batch routes expect in the `kCategory` filter (plattform / non-SCX shop sources) or in the
     * `kWawiCategory` filter (SCX marketplace sources, next to the SCX `kCategory`).
     *
     * Two modes, same as the SCX picker:
     * - `q` — flat search by category name;
     * - `parentKCategory` — lazy tree navigation: a category id for its direct children, `0` for the
     * top-level roots. Each item carries `hasChildren`.
     *
     * Only active categories (`cAktiv <> 'N'`). For non-SCX `shop:N` sources the list is additionally
     * restricted to categories assigned to that shop (`dbo.tKategorieShop`, `cDelInet` semantics);
     * `plattform:N` and SCX marketplace sources see the whole Wawi tree.
     * @param source Channel identifier — composite string `plattform:N` (master / marketplace platform from `dbo.tPlattform`) or `shop:N` (shop instance from `dbo.tShop`). Use the `id` of any entry in `GET /content-master/workspace-config.platforms`.
     * @param dataSourceId
     * @param language Active shop language: kSprache (integer or digit string), or ISO code (cISO2/cISO from Wawi tSpracheUsed). Omit for shop default.
     * @param q Flat search by category name
     * @param parentKCategory Tree navigation: direct children of this kCategory; 0 = top-level roots
     * @param limit
     * @param offset Pagination offset (0-based) — combine with `total`/`hasMore`
     * @returns ContentMasterWawiCategoryListView Matching Wawi categories
     * @throws ApiError
     */
    public static getAppContentMasterCategories(
        source: string,
        dataSourceId?: string,
        language?: string,
        q?: string,
        parentKCategory?: number,
        limit: number = 50,
        offset?: number,
    ): CancelablePromise<ContentMasterWawiCategoryListView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/content-master/categories',
            query: {
                'source': source,
                'dataSourceId': dataSourceId,
                'language': language,
                'q': q,
                'parentKCategory': parentKCategory,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Invalid parameters or Wawi query error`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * List local Content Master products by status (DB-only, full card fields)
     * Paginates rows from `content_master_product` for the authenticated user (no Wawi search). Each item carries the same card keys as the Wawi-search product view (`contentMasterProductId`, `source`, `dataSourceId`, `wawiArtikelId`, `language`, `sku`, `gtin`, `han`, `title`, `mainImageUrl`, `processingStatus`, `bulkErrorMessage`) but read entirely from the S2G DB — so it works cross-channel (`source` optional) for both Content Master bulk and Marketplace listing status tabs. `title`/`sku`/`gtin`/`han`/`mainImageUrl` are the cached S2G values (may be null until captured by a generate/apply run). See the `language` property schema for null semantics.
     * @param processingStatus Filter by local Content Master status; one value or comma-separated. Same allowed values as GET /content-master/products (`processingStatus`).
     * @param source Optional channel filter (plattform:N / shop:N). Omit to list products across ALL channels of the data source (cross-channel status list).
     * @param dataSourceId Optional; must match the authenticated user's data source when provided
     * @param page
     * @param limit
     * @returns ContentMasterLocalProductListView Minimal local product page
     * @throws ApiError
     */
    public static getAppContentMasterProductsLocalByStatusList(
        processingStatus: string,
        source?: string,
        dataSourceId?: string,
        page: number = 1,
        limit: number = 100,
    ): CancelablePromise<ContentMasterLocalProductListView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/content-master/products/local',
            query: {
                'source': source,
                'dataSourceId': dataSourceId,
                'processingStatus': processingStatus,
                'page': page,
                'limit': limit,
            },
            errors: {
                400: `Invalid parameters`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Get one product from Wawi by identity
     * Resolves one article by query `wawiArtikelId` (kArtikel) together with `source` and user DataSource — same triple as canonical `{dataSourceId}:{source}:{wawiArtikelId}` used for productKey. No request body.
     * @param wawiArtikelId Wawi article id (kArtikel)
     * @param source Channel identifier — composite string `plattform:N` (master / marketplace platform from `dbo.tPlattform`) or `shop:N` (shop instance from `dbo.tShop`). Use the `id` of any entry in `GET /content-master/workspace-config.platforms`.
     * @param dataSourceId
     * @param language Active shop language: kSprache (integer or digit string), or ISO code (cISO2/cISO from Wawi tSpracheUsed). Omit for shop default.
     * @returns ContentMasterProductView Product detail
     * @throws ApiError
     */
    public static getAppContentMasterProductDetail(
        wawiArtikelId: number,
        source: string,
        dataSourceId?: string,
        language?: string,
    ): CancelablePromise<ContentMasterProductView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/content-master/product',
            query: {
                'wawiArtikelId': wawiArtikelId,
                'source': source,
                'dataSourceId': dataSourceId,
                'language': language,
            },
            errors: {
                400: `Invalid parameters or Wawi query error`,
                403: `Forbidden (e.g. dataSourceId does not belong to user)`,
                404: `Product not found for this data source, source, and language`,
            },
        });
    }
    /**
     * Generate all content fields for a product (UC-10)
     * AI-generates field values and returns JSON only — **nothing is persisted** as draft versions; call `POST /content-master/save-draft` with the returned keys to store history.
     *
     * **Required `fields`:** non-empty list of API names to generate — core fields (`title`, `shortDescription`, …), Wawi article attributes (`wawiAttr_{kArtikelAttribut}`), and/or Merkmal keys (`wawiMerkmal_{kMerkmal}` / `wawiMerkmalWert_{kMerkmalWert}`) as returned by `GET /content-master/product`. Only listed fields are generated.
     *
     * `urlPath` (the shop URL slug, `cUrlPfad`) is a normal core field here, but it is listed in `GET /content-master/product.generateDefaultExcludedFields`: a "generate all fields" action must leave it unchecked unless the user opts in, so an existing live URL is never replaced by accident. Generated/translated values are normalized server-side into a slug (lowercase ASCII, umlauts transliterated, single hyphens, cut on a hyphen boundary at the column limit).
     *
     * Optional `fieldAllowedValues` maps field API name → list of picklist options. Each option has a required `value` (the exact string the LLM must return — for Merkmal a stringified `kMerkmalWert`, for varchar the picklist string) and an optional `label` used purely as prompt context (e.g. the localized `tMerkmalWertSprache.cWert` text). When omitted, the backend falls back to options read from the Wawi product. If neither side has options for a picklist field, it is silently skipped (Wawi data is often incomplete for Merkmal).
     *
     * Creates `ContentMasterProduct` lazily for usage logging only.
     * @param requestBody
     * @returns ContentMasterGenerateResultView Generated content for all fields
     * @throws ApiError
     */
    public static postAppContentMasterGenerate(
        requestBody: {
            /**
             * Wawi article id (kArtikel)
             */
            wawiArtikelId: number;
            /**
             * Channel identifier — composite string `plattform:N` (master / marketplace platform from `dbo.tPlattform`) or `shop:N` (shop instance from `dbo.tShop`). Use the `id` of any entry in `GET /content-master/workspace-config.platforms`.
             */
            source: string;
            /**
             * Active shop language: kSprache (integer or digit string), or ISO code (cISO2/cISO from Wawi tSpracheUsed). Omit for shop default.
             */
            language: string;
            dataSourceId?: string | null;
            /**
             * API field names to generate (from GET product): core fields, `wawiAttr_*`, `wawiMerkmal_*`, `wawiMerkmalWert_*`. At least one entry.
             */
            fields: Array<string>;
            /**
             * Map of field API name → list of picklist options (`{value, label?}`). `value` is what the LLM must return; `label` is localized context shown in the prompt.
             */
            fieldAllowedValues?: Record<string, Array<ContentMasterGenerateAllowedOptionView>> | null;
            /**
             * Extra product information provided by the user, merged on the CLIENT into one plain-text string (free-text notes + text extracted from up to 3 files). Used only inside the AI prompt of THIS request as product data — never stored, not sent for bulk. Max 50000 characters; longer input is rejected with 400.
             */
            additionalContext?: string | null;
        },
    ): CancelablePromise<ContentMasterGenerateResultView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/content-master/generate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation / service error. Possible \`errorCode\`:
                - \`content_master_invalid_request\` (missing or malformed fields)
                - \`content_master_invalid_language\`
                - \`content_master_ai_generation_failed\` (OpenAI returned non-200, empty, or invalid JSON)
                - \`content_master_wawi_error\` (Wawi query failed)
                - \`content_master_wawi_connection_failed\` (cannot connect to Wawi DB)`,
                403: `Forbidden. Possible \`errorCode\`:
                - \`content_master_forbidden\` (data source / subuser access)
                - \`content_master_quota_exceeded\` — not enough tokens for a new generation
                - \`content_master_subscription_insufficient\` — plan does not allow Wawi attributes/Merkmal (Starter) or only core fields remain after filtering`,
                404: `\`content_master_product_not_found\` — article not found in Wawi`,
            },
        });
    }
    /**
     * Translate product content fields from one language to another
     * AI-translates existing product values from `sourceLanguage` to `targetLanguage` and returns JSON only — **nothing is persisted** as draft versions; call `POST /content-master/save-draft` with the returned keys (and `language = targetLanguage`) to store history.
     *
     * The backend reads source values from the Wawi row for `sourceLanguage` (no default-language fallback) and asks the LLM to translate into `targetLanguage`. Translation stays faithful to the source; no new content is invented.
     *
     * Silently skipped (not returned in `translated`):
     * - `wawiMerkmal_*` / `wawiMerkmalWert_*` (picklist kMerkmalWert ids — not free-form text),
     * - `wawiAttr_*` with integer/decimal/datetime type (numbers do not need translation),
     * - unknown API names.
     *
     * Fields whose source value is empty are returned as empty strings.
     *
     * Creates `ContentMasterProduct` lazily for usage logging only.
     * @param requestBody
     * @returns ContentMasterTranslateResultView Translated content for all supported requested fields
     * @throws ApiError
     */
    public static postAppContentMasterTranslate(
        requestBody: {
            /**
             * Wawi article id (kArtikel)
             */
            wawiArtikelId: number;
            /**
             * Channel identifier — composite string `plattform:N` (master / marketplace platform from `dbo.tPlattform`) or `shop:N` (shop instance from `dbo.tShop`). Use the `id` of any entry in `GET /content-master/workspace-config.platforms`.
             */
            source: string;
            /**
             * Source language to translate from. Active shop language: kSprache (integer or digit string), or ISO code (cISO2/cISO from Wawi tSpracheUsed). Omit for shop default.
             */
            sourceLanguage: string;
            /**
             * Target language to translate to (must differ from sourceLanguage). Active shop language: kSprache (integer or digit string), or ISO code (cISO2/cISO from Wawi tSpracheUsed). Omit for shop default.
             */
            targetLanguage: string;
            dataSourceId?: string | null;
            /**
             * API field names to translate (from GET product): core fields (`title`, `shortDescription`, …) and `wawiAttr_*` varchar attributes. Non-varchar wawiAttr and Merkmal entries are silently skipped. At least one entry.
             */
            fields: Array<string>;
        },
    ): CancelablePromise<ContentMasterTranslateResultView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/content-master/translate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation / service error. Possible \`errorCode\`:
                - \`content_master_invalid_request\` (missing or malformed fields; same source and target language)
                - \`content_master_invalid_language\` (sourceLanguage or targetLanguage not active in shop)
                - \`content_master_ai_generation_failed\` (OpenAI returned non-200, empty, or invalid JSON)
                - \`content_master_wawi_error\` / \`content_master_wawi_connection_failed\``,
                403: `Forbidden. Possible \`errorCode\`:
                - \`content_master_forbidden\`
                - \`content_master_quota_exceeded\``,
                404: `\`content_master_product_not_found\` — article not found in Wawi for the requested sourceLanguage`,
            },
        });
    }
    /**
     * Save draft field versions (UC-14)
     * Saves field versions to S2G without pushing to Wawi. Status becomes `in_progress`. Each field accepts `text` (new value) or `id` (existing version UUID to activate). If both are provided, `text` takes priority.
     *
     * Keys are API names: core fields (`title`, `shortDescription`, …) plus Wawi extensions: `wawiAttr_{kArtikelAttribut}` for `tArtikelAttributSprache` values, and `wawiMerkmal_{kMerkmal}` / `wawiMerkmalWert_{kMerkmalWert}` for characteristics. For Merkmal, `text` must be the string form of a valid `kMerkmalWert` id (numeric), not arbitrary free text.
     *
     * Marketplace listing products also accept `mpAttr_*` keys (the attribute keys returned by `GET /marketplace-listing/review`) to edit a generated marketplace attribute value before apply. Such an edit is stored as a new draft version and the product stays at `listing_generate_done` (so it remains on the marketplace review page); only keys present in the product's generated attribute schema are accepted.
     *
     * `POST /content-master/generate` does **not** write versions — call this endpoint after generating content on the client.
     *
     * `content_master_field_version.field_key` is limited to 100 characters; oversized keys are rejected.
     * @param requestBody
     * @returns ContentMasterSaveResultView Draft saved
     * @throws ApiError
     */
    public static postAppContentMasterSaveDraft(
        requestBody: {
            wawiArtikelId: number;
            /**
             * Channel identifier — composite string `plattform:N` (master / marketplace platform from `dbo.tPlattform`) or `shop:N` (shop instance from `dbo.tShop`). Use the `id` of any entry in `GET /content-master/workspace-config.platforms`.
             */
            source: string;
            /**
             * Active shop language: kSprache (integer or digit string), or ISO code (cISO2/cISO from Wawi tSpracheUsed). Omit for shop default.
             */
            language: string;
            /**
             * Fields to save, keyed by API name (core + `wawiAttr_*` / Merkmal keys as in GET product; `mpAttr_*` keys for marketplace listing products)
             */
            fields: Record<string, {
                text?: string | null;
                id?: string | null;
            }>;
            dataSourceId?: string | null;
        },
    ): CancelablePromise<ContentMasterSaveResultView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/content-master/save-draft',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation / service error. Possible \`errorCode\`:
                - \`content_master_invalid_request\`
                - \`content_master_invalid_language\`
                - \`content_master_field_validation_failed\` (per-field Wawi rule failed)
                - \`content_master_wawi_error\`
                - \`content_master_wawi_connection_failed\``,
                403: `\`content_master_forbidden\` — access denied for the target data source`,
            },
        });
    }
    /**
     * Apply content — save versions and mark done (UC-15)
     * Same as save-draft, but additionally updates Wawi in one transaction: `tArtikelBeschreibung` for core fields, `tArtikelAttributSprache` / `tArtikelMerkmal` for extension keys. If Wawi update fails, local S2G changes are rolled back.
     *
     * Read-only Wawi attributes, unknown `wawiAttr_*` rows, invalid Merkmal ids, or varchar values outside `allowedValues` (when the attribute defines a non-empty picklist) are rejected with a validation error. Exception: an EMPTY `text` always passes the picklist check — it means "clear the attribute value" (an empty option can never be part of `allowedValues`).
     *
     * Merkmal `text` must remain a numeric `kMerkmalWert` as for save-draft.
     * @param requestBody
     * @returns ContentMasterSaveResultView Applied
     * @throws ApiError
     */
    public static postAppContentMasterApply(
        requestBody: {
            wawiArtikelId: number;
            /**
             * Channel identifier — composite string `plattform:N` (master / marketplace platform from `dbo.tPlattform`) or `shop:N` (shop instance from `dbo.tShop`). Use the `id` of any entry in `GET /content-master/workspace-config.platforms`.
             */
            source: string;
            /**
             * Active shop language: kSprache (integer or digit string), or ISO code (cISO2/cISO from Wawi tSpracheUsed). Omit for shop default.
             */
            language: string;
            fields: Record<string, {
                text?: string | null;
                id?: string | null;
            }>;
            dataSourceId?: string | null;
        },
    ): CancelablePromise<ContentMasterSaveResultView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/content-master/apply',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation / service error. Possible \`errorCode\`:
                - \`content_master_invalid_request\`
                - \`content_master_invalid_language\`
                - \`content_master_field_validation_failed\`
                - \`content_master_wawi_apply_failed\` (Wawi UPDATE failed, local changes rolled back)
                - \`content_master_wawi_error\`
                - \`content_master_wawi_connection_failed\``,
                403: `\`content_master_forbidden\` — access denied for the target data source`,
            },
        });
    }
    /**
     * List active Wawi languages (dbo.tSpracheUsed, Wawi 1.11.7.0)
     * @param dataSourceId
     * @returns ContentMasterWawiLanguageListView Languages
     * @throws ApiError
     */
    public static getAppContentMasterLanguages(
        dataSourceId?: string,
    ): CancelablePromise<ContentMasterWawiLanguageListView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/content-master/languages',
            query: {
                'dataSourceId': dataSourceId,
            },
            errors: {
                400: `Wawi error`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Wawi workspace snapshot (languages + sales channels + public global configs)
     * Reads from the connected Wawi (`dbo.tSpracheUsed`, `dbo.tPlattform`, `dbo.tShop`, `dbo.tArtikelBeschreibung`). Nothing is stored in Seller2Go. Returns both platform-level entries (filtered `dbo.tPlattform` rows — JTL-Wawi master, Onlineshop default, Amazon DE/US, eBay, JTL-Fulfillment Network, …) and shop-level entries (every Verkaufskanal from `dbo.tShop`). Each entry's `id` (`plattform:N` or `shop:N`) is the value the frontend MUST send back as `source` in every Content Master request. Additionally, `publicConfigs` contains all global project config rows with `is_public = true` (same items as `GET /v2/api/configs`), so the frontend gets them without an extra round-trip.
     * @param dataSourceId
     * @returns ContentMasterWorkspaceConfigView Workspace snapshot
     * @throws ApiError
     */
    public static getAppContentMasterWorkspaceConfig(
        dataSourceId?: string,
    ): CancelablePromise<ContentMasterWorkspaceConfigView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/content-master/workspace-config',
            query: {
                'dataSourceId': dataSourceId,
            },
            errors: {
                400: `Wawi error`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Aggregated AI token usage for Content Master
     * Aggregated internal-token accounting for the authenticated user. Everything on this endpoint, the
     * generate/translate guards (`POST /content-master/generate`, `POST /content-master/translate`) and
     * the on-demand min-value validator on `PUT /content-master/user-config` are derived from the same
     * calculation so the paths never disagree on usage / overage.
     *
     * All token figures returned by this endpoint are INTERNAL tokens — the price we deduct from the user's
     * CM budget, computed from `(base + fields × per_field) × model_tier_multiplier` (see global configs
     * `content_master_base_tokens_*`, `content_master_tokens_per_field_*`,
     * `content_master_model_tier_*_multiplier`). Raw OpenAI prompt/completion/total counts are kept in
     * `content_master_ai_usage` for analytics but are not exposed here.
     *
     * Fields:
     * - `internalTokens` — SUM(`internal_tokens`) over the optional `dateFrom`/`dateTo` window
     * (unfiltered = all time).
     * - `totalAllowedTokens` — `token_included_count + token_extra_count` from the active Content Master
     * subscription. `null` when no active CM subscription.
     * - `tokensRemaining` — `max(0, totalAllowedTokens - usageInPeriod)` where `usageInPeriod` is
     * `SUM(internal_tokens)` since the period anchor (last paid INITIAL/RENEWAL `Payment`, fallback
     * `subscription.created`). `null` when no active CM subscription.
     * - `overageTokens` — `max(0, usageInPeriod - totalAllowedTokens)`; internal tokens already consumed
     * past the subscription allowance in the current billing period (these will be billed via
     * `ReportOverageUsageCommand`).
     * - `onDemandLimitTokens` — `user_config.content_master_on_demand_limit` (cents) converted to tokens
     * at the current global price (`config.content_master_on_demand_price_cents_per_1000_tokens`).
     * - `onDemandRemainingTokens` — `max(0, onDemandLimitTokens - overageTokens)`; overage already eats
     * into the on-demand budget, so only the unused remainder counts toward new generations.
     * - `canGenerateMore` — informative flag:
     * `(tokensRemaining ?? 0) + onDemandRemainingTokens >=` the base-rate price of one generation
     * (config formula: `content_master_base_tokens_generate` × model tier — no historical averaging).
     * The strict per-call check runs against the EXACT internal-token price of each `/generate` and
     * `/translate` request (model + requested field count) and may reject a heavy request with
     * `403 content_master_quota_exceeded` even when this flag is true.
     * @param dateFrom
     * @param dateTo
     * @returns ContentMasterAiTokensSummaryView Token usage summary
     * @throws ApiError
     */
    public static getAppContentMasterAiTokens(
        dateFrom?: string,
        dateTo?: string,
    ): CancelablePromise<ContentMasterAiTokensSummaryView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/content-master/ai/tokens',
            query: {
                'dateFrom': dateFrom,
                'dateTo': dateTo,
            },
            errors: {
                400: `Invalid dateFrom or dateTo`,
            },
        });
    }
    /**
     * Paginated AI generation history
     * @param page
     * @param limit
     * @param dataSourceId
     * @param language Active shop language: kSprache (integer or digit string), or ISO code (cISO2/cISO from Wawi tSpracheUsed). Omit for shop default.
     * @param source Channel identifier — composite string `plattform:N` (master / marketplace platform from `dbo.tPlattform`) or `shop:N` (shop instance from `dbo.tShop`). Use the `id` of any entry in `GET /content-master/workspace-config.platforms`.
     * @param q Search SKU, GTIN, HAN, title (linked product only)
     * @returns ContentMasterAiHistoryListView History page
     * @throws ApiError
     */
    public static getAppContentMasterAiHistory(
        page: number = 1,
        limit: number = 20,
        dataSourceId?: string,
        language?: string,
        source?: string,
        q?: string,
    ): CancelablePromise<ContentMasterAiHistoryListView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/content-master/ai/history',
            query: {
                'page': page,
                'limit': limit,
                'dataSourceId': dataSourceId,
                'language': language,
                'source': source,
                'q': q,
            },
            errors: {
                400: `Bad request`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Upsert a user config entry (owner scope)
     * Updates the authenticated user's `user_config` row.
     *
     * For `content_master_on_demand_limit` the new cents value cannot be lower than the overage already
     * consumed in the current billing period — that overage will be reported to Stripe and must remain
     * covered by the cap. In that case the response is 400 with
     * `errorCode = content_master_on_demand_limit_below_usage` and the message includes the minimum
     * allowed value (cents).
     *
     * Other Content Master error codes that may appear in 4xx responses:
     * `content_master_invalid_request`, `content_master_unknown_config`, `content_master_invalid_config_value`.
     * @param requestBody
     * @returns any Updated
     * @throws ApiError
     */
    public static putAppContentMasterUserConfig(
        requestBody: {
            name: 'content_master_on_demand_limit';
            value: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v2/api/content-master/user-config',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error (see \`errorCode\`)`,
            },
        });
    }
}
